var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('frame-visual',{attrs:{"id":_vm.id,"initVisualMode":_vm.initVisualMode}})}
var staticRenderFns = []

export { render, staticRenderFns }